<template>
  <div class="riskList">
    <div class="table-box">
      <div class="title">
        <div class="flex justify-start align-center" >
          <div class="icon-box">
            <i class="iconfont icon-daiban"></i>
          </div>
          <b>历史记录</b>
        </div>
        <div class="page-cancel" @click="$router.go(-1)">
          <i class="icon iconfont icon-jiantouzuo1"></i>返回
        </div>
      </div>
      <div class="search-flex">
        <div class="search-box">
          <el-form ref="form" :model="search" label-width="80px" class="flex">
            <el-form-item label="关键词">
              <el-input v-model="search.keyword" clearable placeholder="请输入关键词搜索"></el-input>
            </el-form-item>
            <el-form-item label="预警时间">
                <el-date-picker
                  class="inp"
                  v-model="search.time"
                  clearable
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="-"
                  start-placeholder="请选择"
                  end-placeholder="请选择">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="级别选择">
              <el-select v-model="search.level" clearable placeholder="请选择" class="inp">
                <el-option
                  v-for="item in riskLevelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="search-btn" @click="searchFun">
            <i class="iconfont icon-sousuo"></i>搜索
          </div>
          <div class="search-btn reset" @click="reset">
            <i class="iconfont icon-huanxiang"></i>重置
          </div>
        </div>
      </div>
      <div class="list ">
        <el-table
          border
          :data="tableData"
          :header-cell-style="centerbgc"
          :cell-style="textCenter"
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            width="140"
            label="预警">
            <template slot-scope="scope">
              <div class="btn gray" v-if="scope.row.level == 0">提示</div>
              <div class="btn yellow" v-if="scope.row.level == 1">预警</div>
              <div class="btn orange" v-if="scope.row.level == 2">预警</div>
              <div class="btn red" v-if="scope.row.level == 3">预警</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="info"
            label="信息">
          </el-table-column>
          <el-table-column
            prop="instruction"
            label="描述">
          </el-table-column>
          <el-table-column
            width="150"
            prop="day"
            label="天数">
          </el-table-column>
          <el-table-column
            width="250"
            prop="create_time"
            label="预警时间">
          </el-table-column>
          <el-table-column
            width="250"
            prop="update_time"
            label="处理时间">
          </el-table-column>
          <el-table-column
            width="150"
            prop="status_txt"
            label="状态">
          </el-table-column>
          <el-table-column
            label="操作"
            width="250">
            <template slot-scope="scope" class="flex">
              <div class="edit" @click="download(scope.row)">下载整改证明材料</div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-box">
        <el-pagination
          :current-page.sync="search.page"
          :page-size="search.limit"
          :total="search.total"
          background
          class="page-all margin-top self-end"
          layout="prev, pager, next"
          @current-change="list">
        </el-pagination>
      </div>
    </div>

  </div>
</template>
<script>
import {isYes,riskLevelOptions} from "@/utils/const";
import {warning_lst} from "@/api";
import {
  frontDownload
} from "@/utils/utils";
export default {
  name: "historyList",
  data() {
    return {
      isYes:isYes,
      riskLevelOptions:riskLevelOptions,
      dialogVisible: false,
      search:{
        keyword: '',
        time: '',
        level: '',
        page:1,
        limit:10,
        total:0,
      },
      tableData:[]
    }
  },
  components: {},
  computed: {
    textCenter(){
      return {
        textAlign: 'center'
      }
    },
    centerbgc(){
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.$emit("setActive", {
      headActive: 4
    })
    this.list()
  },
  methods: {
    async list(){
      let _data = await warning_lst(
        this.search.keyword,
        this.search.time ? this.search.time.join(',') : '',
        this.search.level,
        4,
        this.search.page,
        this.search.limit
      );
      if(_data.status == 200) {
        this.tableData = _data.data.data;
        this.search.total = _data.data.total;
      }
    },

    download(row){
      frontDownload(row.cailiao)
    },

    searchFun() {
      this.search.page = 1
      this.tableData = []
      this.list()
    },

    reset() {
      this.search.keyword = ''
      this.search.time = []
      this.search.level = ''
      this.searchFun()
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.riskList {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;
  .table-box {
    width: 100%;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    padding: 0 20px;
    border-radius: 10px;
    min-height: 500px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      border-bottom: 2px solid #e3e7f0;
      b {
        font-size: 22px;
        color: #16181d;
        font-weight: bold;
        margin-left: 10px;
      }
      .icon-box {
        width: 30px;
        height: 30px;
        background-image: linear-gradient(-30deg,
          #3579fb 0%,
          #44a3ff 100%);
        box-shadow: 0px 10px 10px 0px
        rgba(50, 150, 255, 0.3);
        border-radius: 10px;
        text-align: center;
        line-height: 30px;

        i {
          font-size: 20px;
          color: #ffffff;
        }
      }
    }
    .list {
      width: 100%;
      .btn {
        width: 60px;
        height: 26px;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        line-height: 26px;
        margin: 0 auto;
        &.gray {
          color: #8a8a8a;
          background-color: #f2f2f2;
        }
        &.yellow {
          color: #fad471;
          background-color: #fffbdd;
        }
        &.orange {
          color: #f58739;
          background-color: #ffeedd;
        }
        &.red {
          color: #f8001a;
          background-color: #ffdddd;
        }
      }
    }
    .search-flex {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 20px 0;
      .shensu {
        width: 113px;
        height: 37px;
        background-image: linear-gradient(0deg,
          #f59a23 0%,
          #feb555 100%);
        border-radius: 4px;
        text-align: center;
        line-height: 37px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 5px;
          color: #ffffff;
        }
      }
      .search-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .search-btn {
          width: 112px;
          height: 36px;
          background-image: linear-gradient(0deg,
            #2791ff 0%,
            #81b6ff 100%);
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          color: #ffffff;
          margin-left: 15px;
          cursor: pointer;
          i {
            font-size: 20px;
            margin-right: 5px;
            color: #ffffff;
          }
          &.reset {
            background-image:none;
            background-color: #ffffff;
            border-radius: 4px;
            border: solid 1px #cccccc;
            line-height: 34px;
            color: #333333;
            i {
              color: #999999;
            }
          }
        }
      }

    }
  }

}
</style>


